// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._j7yIkWva7BvjTpaRib7{display:flex;align-items:center;min-height:32px;padding-right:4px}`, "",{"version":3,"sources":["webpack://./src/pages/conversations/ui/ConversationList/ui/BulkActions/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CACA,eAAA,CACA,iBAAA","sourcesContent":[".wrap {\n  display: flex;\n  align-items: center;\n  min-height: 32px;\n  padding-right: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `_j7yIkWva7BvjTpaRib7`
};
export default ___CSS_LOADER_EXPORT___;
